const AnomaliesIcon = ({ isSelected }) => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.75 15.5C5.58717 15.5 3.75483 14.749 2.253 13.247C0.751 11.7452 0 9.91283 0 7.75C0 5.58717 0.751 3.75483 2.253 2.253C3.75483 0.751 5.58717 0 7.75 0C9.91283 0 11.7452 0.751 13.247 2.253C14.749 3.75483 15.5 5.58717 15.5 7.75C15.5 8.709 15.3452 9.59133 15.0355 10.397C14.726 11.2028 14.2885 11.9602 13.723 12.6692L18.1655 17.1115C18.3103 17.2565 18.3812 17.4322 18.378 17.6385C18.3747 17.8448 18.3038 18.0205 18.1655 18.1655C18.0205 18.3103 17.8433 18.3827 17.6338 18.3827C17.4241 18.3827 17.2468 18.3103 17.102 18.1655L12.6595 13.723C11.9507 14.2885 11.1949 14.726 10.3923 15.0355C9.58975 15.3452 8.709 15.5 7.75 15.5ZM7.75 14C9.48083 14 10.9552 13.391 12.173 12.173C13.391 10.9552 14 9.48083 14 7.75C14 6.01917 13.391 4.54483 12.173 3.327C10.9552 2.109 9.48083 1.5 7.75 1.5C6.01917 1.5 4.54483 2.109 3.327 3.327C2.109 4.54483 1.5 6.01917 1.5 7.75C1.5 9.48083 2.109 10.9552 3.327 12.173C4.54483 13.391 6.01917 14 7.75 14Z"
      fill={isSelected ? "white" : "black"}
    />
  </svg>
);
export default AnomaliesIcon;
